import { c as _c } from "react/compiler-runtime";
import type { EditorProps, Monaco } from "@monaco-editor/react";
import { Box, Skeleton, useColorScheme } from "@mui/material";
import type { editor } from "monaco-editor";
import dynamic from "next/dynamic";
import React from "react";
import { useMobileLayout } from "#/shared/hooks/useMobileLayout";
const MonacoEditor = dynamic(() => import("@monaco-editor/react"), {
  ssr: false,
  loading: () => <Skeleton variant="rectangular" height="400px" />
});
type CodeRunnerProps = EditorProps & {
  isUpdating?: boolean;
  setMonacoInstance?: React.Dispatch<React.SetStateAction<Monaco | null>>;
  setEditorInstance?: React.Dispatch<React.SetStateAction<editor.IStandaloneCodeEditor | null>>;
  setTextModel: React.Dispatch<React.SetStateAction<editor.ITextModel | null>>;
};
export const CodeRunner: React.FC<CodeRunnerProps> = t0 => {
  const $ = _c(23);
  let height;
  let restProps;
  let setEditorInstance;
  let setMonacoInstance;
  let setTextModel;
  if ($[0] !== t0) {
    ({
      setMonacoInstance,
      setEditorInstance,
      setTextModel,
      height,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = restProps;
    $[3] = setEditorInstance;
    $[4] = setMonacoInstance;
    $[5] = setTextModel;
  } else {
    height = $[1];
    restProps = $[2];
    setEditorInstance = $[3];
    setMonacoInstance = $[4];
    setTextModel = $[5];
  }
  const {
    mode
  } = useColorScheme();
  const isMobile = useMobileLayout();
  const t1 = height === "100%" ? "100%" : undefined;
  const t2 = mode === "dark" ? "app-dark" : "vs-light";
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      enabled: false
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !isMobile;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      enabled: false
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = {
      fontSize: 13,
      minimap: t3,
      tabSize: 2,
      fixedOverflowWidgets: true,
      lineNumbersMinChars: 3,
      lineDecorationsWidth: 6,
      folding: t4,
      stickyScroll: t5,
      wordWrap: "on"
    };
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = typeof height === "number" ? `calc(${height}px - 6vh)` : height;
  let t8;
  if ($[10] !== setEditorInstance || $[11] !== setMonacoInstance || $[12] !== setTextModel) {
    t8 = (editor, monaco) => {
      const model = editor.getModel();
      if (!model) {
        console.error("No model found");
        return;
      }
      setEditorInstance?.(editor);
      setMonacoInstance?.(monaco);
      setTextModel(model);
      monaco.editor.defineTheme("app-dark", {
        base: "vs-dark",
        inherit: true,
        rules: [],
        colors: {
          "editor.background": "#00000000",
          focusBorder: "#00000000"
        }
      });
      monaco.editor.setTheme("app-dark");
    };
    $[10] = setEditorInstance;
    $[11] = setMonacoInstance;
    $[12] = setTextModel;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== restProps || $[15] !== t2 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = <MonacoEditor theme={t2} options={t6} {...restProps} height={t7} onMount={t8} />;
    $[14] = restProps;
    $[15] = t2;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t1 || $[21] !== t9) {
    t10 = <Box position="relative" height={t1}>{t9}</Box>;
    $[20] = t1;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};